export const SplashActionType = {
  GET_SPLASHES_API: 'SPLASH.GET_SPLASHES_API',
  GET_SPLASHES_API_SUCCESS: 'SPLASH.GET_SPLASHES_API_SUCCESS',
  GET_SPLASHES_API_FAILURE: 'SPLASH.GET_SPLASHES_API_FAILURE',
}